








































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketDisabilitas from "@/store/modules/SuketDisabilitas";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import {
  SuketBaseWithRelationship,
  LokasiInterface,
  AnamnesisInterface,
  PemeriksaanInterface
} from "@/types/suket_disabilitas";

import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf
  }
})
export default class SuketDisabilitasTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.Disabilitas);
  suketStore = StoreSuketDisabilitas;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.Disabilitas, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  alamat_type = "ktp";
  tempat_lahir = null;
  status_disabilitas = null;
  keperluan_surat = null;

  lokasi: LokasiInterface = this.defaultLokasi();
  anamnesis: AnamnesisInterface = this.defaultAnamnesis();
  pemeriksaan: PemeriksaanInterface = this.defaultPemeriksaan();

  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  saving = false;
  loadedRatio = 0;

  defaultLokasi(): LokasiInterface {
    return {
      saraf_pusat: false,
      saraf_pusat_ket: null,
      penginderaan: false,
      penginderaan_ket: null,
      ekstremitas_atas: false,
      ekstremitas_atas_sisi: null,
      ekstremitas_atas_ket: null,
      tangan_dominan: false,
      tangan_dominan_sisi: null,
      ekstremitas_bawah: false,
      ekstremitas_bawah_sisi: null,
      ekstremitas_bawah_ket: null,
      lain_lain: false,
      lain_lain_ket: null
    };
  }

  defaultAnamnesis(): AnamnesisInterface {
    return {
      riwayat: null,
      riwayat_tahun: null,
      riwayat_diagnosa: null,
      kemampuan_mengurus_diri: null,
      kemampuan_mengurus_diri_ket: null,
      bepergian: null
    };
  }

  defaultPemeriksaan(): PemeriksaanInterface {
    return {
      fisik_amputasi: false,
      fisik_amputasi_lokasi: null,
      fisik_lumpuh: false,
      fisik_lumpuh_lokasi: null,
      fisik_paraplegi: false,
      fisik_paraplegi_ket: null,
      fisik_cp: false,
      sensorik_netra: false,
      sensorik_netra_jenis: null,
      sensorik_rungu: false,
      sensorik_wicara: false,
      intelektual_grahita: false,
      intelektual_down: false,
      mental_psikososial: false,
      mental_perkembangan: false,
      mental_perkembangan_jenis: null,
      derajat: null,
      mobilitas_jalan: null,
      mobilitas_tangga: null,
      alat_bantu_ada: null,
      alat_bantu_ket: null,
      penyakit_lain_ada: null,
      penyakit_lain_ket: null,
      pengobatan_ada: null,
      pengobatan_ket: null
    };
  }

  mounted() {
    this.fillFromData(this.dataSuket);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get jenisKelamin() {
    if (this.pasien.jk === "L") return "Laki-laki";
    if (this.pasien.jk === "P") return "Perempuan";
    return this.pasien.jk || "-";
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        tempat_lahir: this.tempat_lahir,
        status_disabilitas: this.status_disabilitas,
        lokasi: this.lokasi,
        anamnesis: this.anamnesis,
        pemeriksaan: this.pemeriksaan,
        keperluan_surat: this.keperluan_surat
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  fillFromData(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.umur = val.pasien?.umur_th || this.umur;
      this.alamat_type = val.content.alamat_type;
      this.tempat_lahir = val.content.tempat_lahir;
      this.status_disabilitas = val.content.status_disabilitas;
      this.lokasi = { ...this.defaultLokasi(), ...(val.content.lokasi || {}) };
      this.anamnesis = {
        ...this.defaultAnamnesis(),
        ...(val.content.anamnesis || {})
      };
      this.pemeriksaan = {
        ...this.defaultPemeriksaan(),
        ...(val.content.pemeriksaan || {})
      };
      this.keperluan_surat = val.content.keperluan_surat;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.alamat_type = "ktp";
      this.tempat_lahir = null;
      this.status_disabilitas = null;
      this.lokasi = this.defaultLokasi();
      this.anamnesis = this.defaultAnamnesis();
      this.pemeriksaan = this.defaultPemeriksaan();
      this.keperluan_surat = null;
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketDisabilitas.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    this.fillFromData(val);
  }
}
